import { useEffect } from "react";
import "./Error.css";

function Error({ error }) {
  useEffect(() => {}, []);
  return (
    <div id={"error-Info"}>
      <span id={""}>
        
        {error.contenido?.SMListaErrores
          ? error.contenido?.SMListaErrores?.map((e) => {
              return e.descripcionError;
            })
          : error.errorDsc.repeat(1)}
          
      </span>
    </div>
  );
}

export default Error;
